module.exports = __webpack_public_path__ + "static/media/black-tshirt-back-min.15a1133e.png";